<template>
  <div>
    <div class="page_title">监控大屏-门店操作台</div>
    <div class="page_main flex-col">
      <span class="posName">{{ pos.pos.name }}</span>

      <div v-if="posImg" class="pos_qrcode justify-center">
        <img :src="posImg" alt="" class="qrcodeImg">
      </div>

      <div class="pos_row flex-row">
        <span class="pos_label">当前门店状态：</span>
        <span>{{ pos.workState }}</span>
      </div>

      <div class="pos_row flex-col">
        <div class="label_row pos_label justify-start">当前回话消息：</div>
        <div id="session_container" class="session_container flex-col">
          <div v-for="item of msgList" :key="item.msgID" class="msg_row flex-row">
            <span class="founder">{{ item.nickName }}：</span>
            <van-button v-if="item.msgType == 'user_record'" class="playRecord_button" @click="wxAudioRecord.playRecord(item.msg)">播放语音</van-button>
            <span v-else class="msgText">{{ item.msg }}</span>
          </div>
        </div>
        <el-select v-model="selectedCuePhrasesValue" placeholder="请选择要发送的提示语">
          <el-option
            v-for="item in sessionSelect"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model="inputCuePhrases" class="input_row" placeholder="请输入要发送的提示语"></el-input>
        <el-button class="input_row" type="primary" @click="sendMsg(selectedCuePhrasesText)">发送消息</el-button>
      </div>

      <div class="pos_row flex-col">
        <div class="flex-row justify-between align-center">
          <span class="pos_label">门店服务记录：</span>
          <van-button class="button" plain type="info" @click="hiddenTable('showServiceList')">隐藏/显示</van-button>
        </div>
        <div v-show="showServiceList">
          <table>
            <thead>
            <tr>
              <td>时间</td>
              <td>内容</td>
              <td>状态</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) of serviceList" :key="index">
              <td>{{ item.order.createTime }}</td>
              <td>
                <span v-for="(i,index) of item.lstProduct" :key="index">{{ i.name }}</span>
                <span v-if="item.order.plateNum">({{ item.order.plateNum }})</span>
              </td>
              <td>{{ item.state }}</td>
            </tr>
            </tbody>
          </table>
          <div v-if="serviceList.length === 0" class="nullServiceList justify-center">暂无数据</div>
        </div>
      </div>

      <div class="pos_row flex-col">
        <div class="flex-row justify-between align-center">
          <span class="pos_label">门店在售商品与服务：</span>
          <van-button class="button" plain type="info" @click="hiddenTable('showProductList')">隐藏/显示</van-button>
        </div>
        <div v-show="showProductList">
          <table>
            <thead>
            <tr>
              <td>商品</td>
              <td>价格</td>
              <td>选择</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) of pos.lstProduct" :key="index">
              <td>{{ item.product.name }}</td>
              <td>￥{{ item.yuanPrice }}元</td>
              <td class="flex-row align-center justify-center">
                <input class="purchase_checkbox" type="checkbox">本次采购
              </td>
            </tr>
            </tbody>
          </table>
          <!--          <div class="productButton flex-row justify-end">
                      <el-button type="primary">代客下单，链点支付</el-button>
                    </div>-->
        </div>
      </div>

      <div class="pos_row flex-col">
        <div class="flex-row justify-between align-center">
          <span class="pos_label">当前用户信息：</span>
          <van-button class="button" plain type="info" @click="hiddenTable('showUserDetail')">隐藏/显示</van-button>
        </div>
        <div v-show="showUserDetail">
          <div v-if="order">
            <table class="user_detail_table">
              <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th>当前用户</th>
                <td>{{ user.nickName }}</td>
              </tr>
              <tr class="user_row">
                <th class="th_left">位置</th>
                <td class="td_right">距离门店
                  <span v-if="user.position">{{ user.position }}</span>
                  <span v-else>未知距离</span>
                </td>
              </tr>
              <tr>
                <th>手机</th>
                <td>{{ user.phone }}</td>
              </tr>
              <tr>
                <th>车牌</th>
                <td v-if="user.plateNum">{{ user.plateNum }}</td>
                <td v-else>暂无车牌</td>
              </tr>
              <tr>
                <th>链点</th>
                <td>{{ user.points }}</td>
              </tr>
              <tr>
                <th>默认服务</th>
                <td>{{ user.carWashMethod }}</td>
              </tr>
              <tr>
                <th>未服务订单</th>
                <td>
                  <table>
                    <thead>
                    <tr>
                      <td>商品</td>
                      <td>金额</td>
                      <td>备注</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>{{ order.name }}</td>
                      <td>￥{{ order.price }}</td>
                      <td>
                        <span v-if="order.points > 0">链点{{ order.points }}</span>
                        <span v-if="order.amount > 0">+微信￥{{ order.amount }}</span>
                        <span v-if="order.balnce > 0">+余额￥{{ order.balnce }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="flex_row input_row">
              <van-button
                v-for="item of buttons"
                :key="item.id"
                class="button service_button"
                plain
                type="info"
                @click="serviceButton(item.id)">{{ item.name }}
              </van-button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  findAllAutomanAccount,
  findAllYijieAccount,
  getOrderInfo,
  queryOrderByPosId,
  queryPosDetailByPosId,
  queryUserInfo,
  queryUserPoints
} from "../graphql/api";
import {adminStartWash, orderComplete, refund} from "../api";
import {mqttConnect, mqttPublish} from "../util/mqttMonitor";
import {v4 as uuidv4} from 'uuid';
import moment from "moment";
import {wxAudioRecord} from "../util/wxAudioRecord";

export default {
  name: "pos_monitor_handler",
  data() {
    return {
      posId: '',
      order: null,

      sessionText: '现场车牌识别可能失效，您需要退后您的车辆，再次尝试',
      showServiceList: true,
      showProductList: true,
      showUserDetail: true,
      nullProduct: false,
      msgList: [],

      points: '',
      yuanPoints: '',
      pos: {
        pos: {
          name: ''
        },
        state: '',
      },
      selectedCuePhrasesValue: 0, //被选中的提示语
      selectedCuePhrasesText: '现场车牌识别可能失效，您需要退后您的车辆，再次尝试',
      inputCuePhrases: "", //输入的提示语
      sessionSelect: [
        {
          id: 0,
          text: '现场车牌识别可能失效，您需要退后您的车辆，再次尝试'
        }, {
          id: 1,
          text: '小敏马上帮您启动洗车,请稍后'
        }, {
          id: 2,
          text: '请查看现场指示灯，确保指示灯为红色，三秒后将启动洗车'
        }, {
          id: 3,
          text: '网点机器故障，请到其他网点洗车'
        },
      ],
      serviceList: [],
      productList: [],
      buttons: [
        {
          id: 0,
          name: '无法服务，已退款'
        }, {
          id: 1,
          name: '请求机器人完成服务'
        }, {
          id: 2,
          name: '人工处理，已完成服务'
        }
      ],
      posImg: '',

      orderInfo: {},

      user: {
        position: "",
        nickName: "",
        phone: "",
        plateNum: "",
        points: "",
        carWashMethod: ""
      },

      unservedOrder: [{
        id: "",
        name: "",
        price: "",
        amount: "",
        points: "",
      }],

      cardList: [],  // 启动洗车的支付账户列表，有多个账户时管理需要进行选择
      showCardList: false,
      cardId: '',

    }
  },
  computed:{
    wxAudioRecord() {
      return wxAudioRecord
    },
    // ...mapState(["userAllEventLog"])
  },
  watch: {
    selectedCuePhrasesValue: function () {
      for (const item of this.sessionSelect) {
        if (this.selectedCuePhrasesValue === item.id) {
          this.selectedCuePhrasesText = item.text;
        }
      }
    },
    inputCuePhrases: function () {
      this.selectedCuePhrasesText = this.inputCuePhrases;
      console.log('当前发送的提示语是', this.selectedCuePhrasesText);
    }
  },
  mounted() {
    this.posInfoInit();
    this.orderInfoInit();
    // this.uesrEventLogMsg();
  },
  destroyed() {
    // mqttEnd();
    sessionStorage.removeItem("currentMsg");
  },
  methods: {
    // 网点信息初始化
    posInfoInit() {
      if (this.$route.query.posId) {
        this.posId = this.$route.query.posId
        this.queryPosInfo();
        this.getServiceList();

        let topic = `ccnet/omc/#`
        mqttConnect(topic, this.mqttCallback, this.posId);
      }
    },

    // 查询网点详细信息
    queryPosInfo() {
      let params = {
        posId: this.posId
      }
      queryPosDetailByPosId(params).then(res => {
        console.log('当前门店是', res.data.findPosInfoByPosId);
        this.pos = res.data.findPosInfoByPosId;
        if (res.data.findPosInfoByPosId.posAdditionInfo && res.data.findPosInfoByPosId.posAdditionInfo.deliveryUrl) {
          this.posImg = res.data.findPosInfoByPosId.posAdditionInfo.deliveryUrl;
        }
        this.dataHandle(this.pos)
      }).catch(error => {
        alert(`查询网点信息异常${error}`);
      })
    },

    // 门店数据处理
    dataHandle(data) {
      if (data.lstProduct !== null) {
        for (const item of data.lstProduct) {
          let yuanPrice = ((item.realPrice) / 100).toFixed(2);
          this.$set(item, 'yuanPrice', yuanPrice);
        }
      } else {
        this.nullProduct = true
      }

      const {state} = data.pos;
      if (state == 1 || state == 100) {
        this.$set(data, "workState", "正常营业")
      } else if (state == 150 || state == 200 || state == 300) {
        this.$set(data, "workState", "工作中")
      } else if (state == 3) {
        this.$set(data, "workState", "维护")
      } else if (state == 4) {
        this.$set(data, "workState", "停业")
      } else if (state == 2 || state == 0) {
        this.$set(data, "workState", "离线")
      } else if (state == 400) {
        this.$set(data, "workState", "故障")
      }
    },

    // 查询网点服务记录
    getServiceList() {
      let params = {
        posId: this.posId,
        page: 1,
        size: 10
      }
      queryOrderByPosId(params).then(res => {
        if (res.data.findOrderByPosId) {
          this.serviceList = res.data.findOrderByPosId;
          for (const item of this.serviceList) {
            if (item.order.completeState === 1) {
              this.$set(item, "state", "未支付");
            } else if (item.order.completeState === 2) {
              this.$set(item, "state", "已支付，待服务");
            } else if (item.order.completeState === 3) {
              this.$set(item, "state", "完成");
            } else if (item.order.completeState === 4) {
              this.$set(item, "state", "已退款");
            }
          }
        }
      }).catch(error => {
        alert(`查询网点服务记录异常${error}`);
      })
    },

    // 用户信息初始化
    orderInfoInit() {
      if (sessionStorage.getItem('currentMsg')) {
        this.msg = JSON.parse(sessionStorage.getItem('currentMsg'));
        this.msgList.push(this.msg);
        this.queryOrderInfo(this.msg.orderId);
      }
    },

    //用户行为信息初始化
   /* uesrEventLogMsg(){
      console.log("-------------------","用户行为信息")
         for(const it of this.userAllEventLog){
           if(this.msg.orderId ===it.orderId){
             for (const item of it.eventList){
               if(item.describe){
                 let msg =JSON.parse(item.describe);
                 this.msgList.push(msg);
                 console.log("----------------------",this.msgList)
               }
             }
           }
         }
    },*/


    // 查询订单信息
    queryOrderInfo(orderId) {
      let params = {
        orderId: orderId
      }
      getOrderInfo(params).then(res => {
        console.log('查到的订单信息', res);
        if (res.data.queryOrderInfo[0]) {
          let data = res.data.queryOrderInfo[0];
          let price = Number((data.order.pointsPay + data.order.amount + data.order.balancePay) / 100).toFixed(2)
          this.order = {
            name: data.o2pList[0].productName,
            price: price,
            points: data.order.pointsPay,
            amount: Number(data.order.amount / 100).toFixed(2),
            balnce: Number(data.order.balancePay / 100).toFixed(2)
          }
          let userAccount = res.data.queryOrderInfo[0].order.userAccount;
          this.findUserInfo(userAccount)
        }
      }).catch(error => {
        alert(`查询订单异常${error}`)
      })
    },

    // 查询用户信息
    findUserInfo(userAccount) {
      // 查询用户详细信息
      queryUserInfo(userAccount).then(res => {
        console.log('查询用户信息');
        let data = res.data.findUserByUserAccount;
        this.$set(this.user, "payMethod", data.carWashMethod);
        let carWashMethod;
        if (data.carWashMethod === 4) {
          carWashMethod = "快洗"
        } else if (data.carWashMethod === 2) {
          carWashMethod = "精洗"
        } else if (data.carWashMethod === 1) {
          carWashMethod = "快洗"
        } else {
          carWashMethod = "未设置"
        }
        // 查询用户链点
        queryUserPoints(userAccount).then(res => {
          if (res.data.findOnePoints) {
            this.points = res.data.findOnePoints.points;
            this.yuanPoints = (this.points / 100).toFixed(2)
          } else {
            this.points = 0;
          }

          this.user = {
            nickName: this.msg.nickName,
            userAccount: this.msg.userAccount,
            position: this.msg.position,
            phone: data.phone,
            plateNum: this.msg.plateNum,
            points: this.points,
            carWashMethod: carWashMethod
          }
        }).catch(error => {
          alert(`查询用户链点异常${error}`)
        })
      }).catch(error => {
        alert(`查询用户信息异常${error}`)
      });
    },

    // 隐藏、显示表格
    hiddenTable(value) {
      console.log('value', value);
      if (value === 'showServiceList') {
        this.showServiceList = !this.showServiceList
      } else if (value === 'showProductList') {
        this.showProductList = !this.showProductList
      } else if (value === 'showUserDetail') {
        this.showUserDetail = !this.showUserDetail
      }
    },


    // 接收MQTT消息
    mqttCallback(message) {
      this.msg = message;
      this.msgList.push(this.msg);

      if (this.msg.msgType==='user_record'){wxAudioRecord.playRecord(this.msg.msg)}

/*
      if(this.msg.msg == "user_record"){
        wxAudioRecord.playRecord(this.msg.msg);
      }
*/

      this.queryOrderInfo(this.msg.orderId);
      let element = document.getElementById('session_container');
      element.scrollTop = element.scrollHeight + element.clientHeight;
    },

    // 发送消息
    sendMsg(adminMsg) {
      if (this.msg) {
        console.log('admin', adminMsg);
        if (adminMsg === '' || adminMsg.replace(/^\s*|\s*$/g, "") === "") {
          alert('请输入要发送的消息！')
        } else {
          let msg = {
            msgID: uuidv4(),
            msgType: "chat_msg",
            timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
            from: 'omc',
            to: 'user',
            nickName: '管理员',
            posId: this.pos.pos.posId,
            msg: adminMsg,
          }
          let topic = `ccnet/user/${this.posId}/${this.msg.userAccount}`
          mqttPublish(topic, msg);
          this.msgList.push(msg);
          let element = document.getElementById('session_container');
          element.scrollTop = element.scrollHeight + element.clientHeight;
        }
      } else {
        alert('当前没有用户在此消费！')
      }
    },

    // 服务按钮组(事件委托)
    serviceButton(id) {
      // 退款
      if (id === 0) {
        let params = {
          orderId: this.msg.orderId
        }
        refund(params).then(res => {
          console.log('调退款接口响应拦截', res);
          if (res.data.retcode === 0) {
            alert('退款成功')
          } else {
            alert(`${res.data.retmsg}`)
          }
        }).catch(error => {
          alert(`退款失败${error}`)
        })

        // 管理员启动洗车
      } else if (id === 1) {
        let params = {
          orderId: this.msg.orderId
        };
        adminStartWash(params).then(res => {
          console.log('启动洗车响应拦截', res);
          if (res.data.retcode === 0) {
            alert('启动洗车机成功')
          } else {
            alert(`${res.data.retmsg}`)
          }
        }).catch(error => {
          alert(`启动洗车失败${error}`)
        })

        // 管理员确认订单完成
      } else if (id === 2) {
        orderComplete(this.msg.orderId).then(res => {
          console.log('确认订单完成', res);
          if (res.data.retcode === 0) {
            alert('管理员确认订单完成成功')
          } else {
            alert(`${res.data.retmsg}`)
          }
        }).catch(error => {
          alert(`确认订单失败${error}`)
        })
      }
    },

    // 确认支付账户
    confirmCard() {
      if (this.cardId !== "") {
        let params;
        if (this.pos.pos.fromnode === "automan") {
          params = {
            orderId: this.msg.orderId,
            payMethod: 0,  //小猫只有手工启动
            cardId: this.cardId
          }
        } else if (this.pos.pos.partnerId === "M202304240014") {
          params = {
            orderId: this.msg.orderId,
            payMethod: 1,  //易捷只有自动启动
            cardId: this.cardId
          }
        }
        console.log('传递的参数是', params);
        this.adminStartWash(params)
      } else {
        this.$dialog({
          title: '提醒',
          message: '请选择支付账户!'
        }).then(res => {
          this.showCardList = true;
        })
      }
    },

    // 播放语音
    payRecord(msg){
      wx.downloadVoice({
        serverId: msg, // 需要下载的音频的服务器端ID，由uploadVoice接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: function (res) {
          let localId = res.localId; // 返回音频的本地ID
          console.log('语音ID=',localId);
          wx.playVoice({
            localId: localId, // 需要播放的音频的本地ID，由stopRecord接口获得
            fail: function (res) {
              alert(`播放语音失败：${JSON.stringify(res)};localId=${localId}`)
            }
          });
        },
        fail: function (res) {
          alert(`下载语音失败${JSON.stringify(res)},msg=${msg}`)
        }
      });
    },
  },
}
</script>
<style scoped src="../css/pos_monitor_handler.css">

</style>
<style scoped src="../css/common.css">

</style>



// WEBPACK FOOTER //
// src/views/pos_monitor_handler.vue